const data = [
  {
    content: "<p>Un élément important pour trouver l'adresse du comte est caché dans ce texte.</p>",
    read: false,
    display: false,
    vue: "book",
    id: 1
  },
  {
    content: "<p>On dirait que le drôle d'animal essaie de dire quelque chose.</p>",
    read: false,
    display: false,
    vue: "book",
    id: 2
  },
  {
    content: "<p>Il se pourrait que ses propos soient codés, un lien avec un drôle d'animal ?</p>",
    read: false,
    display: false,
    vue: "book",
    id: 3
  },
  {
    content: 'Il y a des des "brou" courts et des "bouuu" longs.',
    read: false,
    display: false,
    vue: "book",
    id: 4
  },
  {
    content: "<p>Les propos de l'animal sont codés en morse.</p>",
    read: false,
    display: false,
    vue: "book",
    id: 5
  },
  {
    content: "<p>Ces châteaux sont ceux que visitent les enfants dans le conte.</p>",
    read: false,
    display: false,
    vue: "castle",
    id: 10
  },
  {
    content:
      '<p>Voici pour chaque lettre trouvée sur les visuels le nom du château correspondant :<br /> – "S" : château de Mir.<br />– "L" : château de Durham.<br />– "V" : château de Malbork.<br />– "E" : château de Budapest.<br />– "I" : château d\'Eggenberg.</p>',
    read: false,
    display: false,
    vue: "castle",
    id: 11
  },
  {
    content:
      "<p>Voici pour chaque château son année d'inscription au patrimoine mondial de l'UNESCO :<br />– Château de Mir : 2000.<br />– Château de Durham : 1986.<br />– Château de Malbork : 1997.<br />– Château de Budapest : 2002.<br />– Château d'Eggenberg : 1999.</p>",
    read: false,
    display: false,
    vue: "castle",
    id: 12
  },
  {
    content:
      "<p>Il faut réellement envoyer un email à l'adresse indiquée pour recevoir la clé. Pensez à vérifier vos spams !</p>",
    read: false,
    display: false,
    vue: "receipe",
    id: 21
  },
  {
    content:
      "<p>S'il y a eu un problème de réception, la clé est YOUTUBE. La première étape est de recopier cette clé autant de fois que nécessaire sous le message codé, puis de suivres la consigne de décryptage : <br /><br />BCLHNIIC ZY LIVVGFY WO EVYUIG LFJPOCG JSIKWYK GPX<br />YOUTUBEY OU TUBEYOU TU BEYOUT UBEYOUT UBEYOUT UBE</p>",
    read: false,
    display: false,
    vue: "receipe",
    id: 22
  },
  {
    content:
      '<p>Si l\'on suit bien la consigne, pour décoder la première lettre il faut : – Chercher la ligne avec la lettre "Y". – Rechercher dans cette ligne la lettre "B". – Rergarder la lettre qui se trouve en haut de cette colonne : "D". Et ainsi de suite pour les autres lettres.</p>',
    read: false,
    display: false,
    vue: "receipe",
    id: 23
  },
  {
    content:
      "<p>C'est trop fastidieux ? Il existe aussi des décodeurs en ligne ! Une fois le message decrypté, on trouve la phrase suivante : DOROTHEE LE SOURIRE DU DRAGON REFRAIN PREMIER MOT.</p>",
    read: false,
    display: false,
    vue: "receipe",
    id: 24
  },
  {
    content: "<p>ZUP</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 31
  },
  {
    content: "<p>BANAL</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 32
  },
  {
    content: "<p>MOLLO</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 33
  },
  {
    content: "<p>TRUIES</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 34
  },
  {
    content: "<p>EPAULE</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 35
  },
  {
    content: "<p>RABBIN</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 36
  },
  {
    content: "<p>POLOGNE</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 37
  },
  {
    content: "<p>ROBINET</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 38
  },
  {
    content: "<p>FIOLES</p>",
    read: false,
    display: false,
    vue: "crossword",
    id: 39
  },
  {
    content:
      "<p>Si vous avez trouvé le château du comte, alors ces deux oeuvres devraient vous aider à trouver le mot de passe pour entrer à l'intérieur.</p>",
    read: false,
    display: false,
    vue: "paint",
    id: 42
  },
  {
    content:
      "<p>À l'entrée du chaâteau, il est indiqué qu'il est question de drapeau. Le conte précise aussi que le comte est passé par les pays suivants : l'Allemagne, la Belgique, la Bulgarie, l'Estonie, l'Irlande, la Lituanie et la Roumanie.</p>",
    read: false,
    display: false,
    vue: "paint",
    id: 43
  },
  {
    content:
      "<p>Il faut reconstituer chaque drapeau à l'aide des rectangles colorés des oeuvres, en respectant bien le sens de chacun (vertical ou horizontal), et dans l'odre des pays visités par le conte. La première oeuvre vous permet de reconsituer les trois premiers drapeaux et la seconde les quatre suivants.</p>",
    read: false,
    display: false,
    vue: "paint",
    id: 44
  },
  {
    content: "<p>Enigme 1 : Sées.</p>",
    read: false,
    display: false,
    vue: "quiz",
    id: 51
  },
  {
    content: "<p>Enigme 2 : Eu.</p>",
    read: false,
    display: false,
    vue: "quiz",
    id: 52
  },
  {
    content: "<p>Enigme 3 : Aisne.</p>",
    read: false,
    display: false,
    vue: "quiz",
    id: 53
  },
  {
    content: "<p>Enigme 4 : Tay (Le bois du).</p>",
    read: false,
    display: false,
    vue: "quiz",
    id: 54
  },
  {
    content: 'On peut remplacer phonétiquement chaque réponse par une lettre ("Sées"=C)',
    read: false,
    display: false,
    vue: "quiz",
    id: 55
  },
  {
    content: "<p>Il s'agit du château du comte. Son adresse est peut-être cachée quelque part.</p>",
    read: false,
    display: false,
    vue: "picture",
    id: 61
  },
  {
    content: 'L\'adresse ne fonctionne pas ? Il faut sûrement remplacer les "x" par autre chose.',
    read: false,
    display: false,
    vue: "picture",
    id: 63
  },
  {
    content:
      "<p>Le conte et le journal vous permettent de trouver des mots, pourquoi ne pas les utiliser ici ?</p>",
    read: false,
    display: false,
    vue: "picture",
    id: 64
  },
  {
    content:
      "<p>Pour remplacer chaque mot, il suffit de compter le nombre de caractères de chaque mot et le nombre \"x\" de chaque portion de l'adresse, et d'un peu de logique. Cinq mots sont nécessaires pour avoir l'adresse complète.</p>",
    read: false,
    display: false,
    vue: "picture",
    id: 65
  }
];
export default data;
